module.exports = __webpack_public_path__ + "naghmeh-social-icon--bandcamp.svg?f44f140df859f86f3109cad95f7eb805";


//////////////////
// WEBPACK FOOTER
// ./src/assets/social-icons-edited/naghmeh-social-icon--bandcamp.svg
// module id = 54
// module chunks = 0